import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const RemoveAccountPage = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <div>
        <h1 className='h3 mb-5'>{t('removeaccountpage.title')}</h1>

        <div
          dangerouslySetInnerHTML={{
            __html: t('removeaccountpage.end-subscription')
          }}
        />

        <Link to='/' className='btn btn-primary mb-5'>
          {t('removeaccountpage.back-to-home')}
        </Link>

        <div
          dangerouslySetInnerHTML={{
            __html: t('removeaccountpage.remove-account')
          }}
        />

        <p>
          <a href='https://enzoway.com/support/' target='_blank' rel='noreferrer' className='btn btn-link'>
            https://enzoway.com/support/
          </a>
        </p>

        <Link to='/login'>{t('back')}</Link>
      </div>
    </Container>
  );
};
